import React from 'react';
import { Input } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import fields, { fieldLengths } from '@/constants/fields';

const CohortFilterValuesInput = ({
  filterUUID,
  values,
  disabled,
  onChange,
  saveErrors,
}) => {
  const intl = useIntl();
  const validationError = saveErrors.find((e) => (
    e.context.filterUUID === filterUUID && e.fields.includes(fields.VALUE)));

  return (
    <Input
      error={!!validationError}
      className="aridhia-cohort-filter-values-input"
      size="large"
      fluid
      value={values[0] || ''}
      disabled={disabled}
      onChange={(e) => onChange([e.target.value])}
      maxLength={fieldLengths.xbig}
      placeholder={intl.formatMessage({ id: 'cohort.filter.text.placeholder' })}
    />
  );
};

export default CohortFilterValuesInput;
